/**
 * External dependencies
 */
import React, { useState, useCallback, useMemo } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Container, Row, Col } from "react-bootstrap"
import { sitenameseo } from "@constants";
/**
 * Internal dependencies
 */
import { Link } from "gatsby"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
// import usePropertySlider from "./use-property-slider"
import { convertGatsbyImageNodes } from "../../utils/gatsby-images"
// import slider from "./static/slider"
import Modal from "../modal/modal"
import ImageTransform from "../common/ggfx-client/module/components/image-transform";
import { currencyFormat } from "@components/common/utils";
import Noimg from "../../components/no-img/Noimg"
import PlayVideo from "../Play/playVideo-Iframe";
import Portal from "../portal/portal"
import "./styles/_index.scss"
import ReactPlayer from "react-player"
const PropertySlider = (props) => {
  const settings = {
    dots: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    mobileFirst: true,
    autoPlay: true,
    responsive: [
      {
        breakpoint: 1402,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 377,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const trackerVideo = (event) => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Download Brochure',
        'formType': event,
        'formId': 'Property Detail - Download Brochure',
        'formName': 'Download Brochure',
        'formLabel': 'Property Detail - Download Brochure'
      });
    }
  }
  // Property images lightbox
  const [photoIndex, setPhotoIndex] = useState(1);
  const [isOpen, setIsOpen] = useState(false);

  const openPropertyImage = (e, ind) => {
    e.preventDefault();
    setPhotoIndex(ind);
    // setIndex(ind)
    setIsOpen(true);
  }
  // Property images lightbox

  // Property details images lightbox
  var propertyLightImages = props.data?.images && props.data?.images?.map(img => img?.url ? img.url : img?.srcUrl);
  // Property details images lightbox

  // Property details image count
  const [indexed, setIndex] = useState(1);

  const afterChangeHandler = (d) => {
    setPhotoIndex(parseInt(d) + 1)
    setIndex(parseInt(d) + 1)
  }
  // Property details image count

  const floorplanImages = props.data?.floorplan

  // Property floorplan images lightbox
  const [floorIndex, setFloorIndex] = useState(0);
  const [floorisOpen, setIsFloorOpen] = useState(false);

  const openFloorImage = (e, ind) => {
    e.preventDefault();
    setFloorIndex(ind);
    setIsFloorOpen(true);
  }

  var propertyLightImagesFloorplan = floorplanImages && floorplanImages?.map(img => img?.url ? img.url : img?.srcUrl);
  // Property floorplan images lightbox

  const brouchureImages = props.data?.brouchure

  // Property floorplan images lightbox
  const [brouchureIndex, setbrouchureIndex] = useState(0);
  const [brouchureisOpen, setIsbrouchureOpen] = useState(false);

  const openbrouchureImage = (e, ind) => {
    e.preventDefault();
    setbrouchureIndex(ind);
    setIsbrouchureOpen(true);
  }

  var propertyLightImagesbrouchure = brouchureImages && brouchureImages?.map(img => img.url);
  // Property floorplan images lightbox

  const [modalShow, setModalShow] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  // const data = usePropertySlider()
  // const images = convertGatsbyImageNodes(data)

  // const slides = useMemo(
  //   () =>
  //     slider.map(item => {
  //       if (item.image) {
  //         return {
  //           type: "image",
  //           value: images[item.image],
  //         }
  //       }
  //       return {
  //         type: "video",
  //         value: item.video,
  //         placeholder: images[item.placeholder],
  //       }
  //     }),
  //   [images]
  // )

  // const closeModal = useCallback(() => setModalShow(false), [])

  // const onVideoOpen = useCallback(
  //   (src = "https://www.youtube.com/watch?v=ScMzIvxBSi4") => {
  //     setModalContent(<Modal.Video src={src} autoplay={true} />)
  //     setModalShow(true)
  //   },
  //   []
  // )

  const onGalleryOpen = useCallback((gallery, index) => {
    setModalContent(<Modal.Gallery gallery={gallery} index={index} />)
    setModalShow(true)
  }, [])

  // const onFloorplanOpen = useCallback(src => {
  //   setModalContent(<Modal.Pdf src={src} />)
  //   setModalShow(true)
  // }, [])

  const [isPortalOpen, setIsPortalOpen] = useState(false)
  const [play, setPlayVideo] = useState(false)
  const playVideo = () => setPlayVideo(true)

  const handleClick = () => {
    setIsPortalOpen(true)
    playVideo()
  }

  // const closeOnEsc = e => e.key === "Escape" && setIsPortalOpen(false)

  // virtual_tour entries can be plain url strings or objects ({ url }) depending on the property feed
  const virtualTourItem = props?.data?.virtual_tour?.[0];
  const virtualTour = typeof virtualTourItem === "string" ? virtualTourItem : virtualTourItem?.url || virtualTourItem?.srcUrl || "";

  const URL_Checker = url => {
    if (!url) return null
    let URL = url.indexOf("vt.ehouse.co.uk") > -1 || url.indexOf("matterport.com") > -1
    return URL;
  }

  // Image fallback logic
  const ImageRenderList = ({ imagesources, renderer, imagename, attr, imagetransformresult, id, imagesrc, noimagename }) => {
    if (imagesources) { return ( <ImageTransform imagesources={imagesources} renderer={renderer} imagename={imagename} attr={attr} imagetransformresult={imagetransformresult} id={id} /> ); }
    if (imagesrc) { return ( <img src={imagesrc} alt={attr?.alt} loading="lazy" /> ); }
    return <Noimg imagename={noimagename} />;
  };

  const { extra: { isSalePriceDisclosed = false, salePrice = null } = {} } = props?.data || {};
  const showSalePrice = isSalePriceDisclosed && salePrice;

  return (
    <div className="property-slider-wrapper">

      <Container className="property-slider">
        <Row>
          <Col xs={12} lg="auto" className="property-slider__featured hover-zoom">
            <div className="position-relative h-100 d-flex flex-column justify-content-end">
              <div
                // onClick={() => onGalleryOpen(slides, 0)}
                // onClick={(e) => openPropertyImage(e, 0)}
                className="property-slider__featured-image clear-btn position-absolute w-100 h-100"
              >
                {props?.data?.status === "Sold" ?
                  <div className={`property-details-badge ${showSalePrice ? "sold" : "no-price"}`}>{props?.data?.status} {showSalePrice && `for ${currencyFormat(salePrice, '£', false)}`}</div>
                  :
                  <div className={props?.data?.status === "Sold Subject To Contract" || props?.data?.status === "Let Agreed" ? "property-details-badge yellow" : "property-details-badge"}>{props?.data?.status}</div>
                }
                {props?.data?.images?.length > 0 && props?.data?.images ?

                  <Slider {...settings}
                    afterChange={
                      v => afterChangeHandler(v)
                    }
                  >
                    {
                      props?.data?.images.map((node, i) => {
                        let processedImages = JSON.stringify({});
                        if (props.data?.imagetransforms?.images_Transforms) {
                          processedImages = props.data.imagetransforms.images_Transforms;
                        }

                        return (

                          <div className="" >
                            <ImageRenderList
                              imagesources={node?.url}
                              renderer="srcSet"
                              imagename="property.images.detailbig"
                              attr={{ alt: `${props.data?.display_address} - ${sitenameseo}`, class: '' }}
                              imagetransformresult={processedImages}
                              id={props.data?.id}
                              imagesrc={node?.srcUrl}
                              noimagename="coming-soon-image.Image.detailbig"
                            />
                          </div>
                        )
                      })
                    }

                  </Slider>
                  : <Noimg imagename="coming-soon-image.Image.detailbig" />}

              </div>

              <div className="property-slider__featured-options position-relative">
                <Row className="g-0">
                  {props?.data?.images?.length > 0 &&
                    <Col
                      xs="auto"
                      className="property-slider__progress fw-bolder text-center"
                    >
                      <span>{indexed}/{props?.data?.images?.length}</span>
                    </Col>
                  }
                  {props?.data?.images?.length > 0 &&
                    <Col xs="auto" className="property-slider__option">
                      <button
                        className="clear-btn d-flex align-items-center"
                        // onClick={() => onGalleryOpen(slides, 0)}
                        onClick={(e) => openPropertyImage(e, 0)}
                      >
                        <i className="icon icon--camera" />
                        <span className="d-none d-md-inline-block">
                          View Gallery
                        </span>
                      </button>
                    </Col>
                  }
                  {props.data?.floorplan?.length > 0 &&
                    <Col xs="auto" className="property-slider__option">
                      <button
                        className="clear-btn d-flex align-items-center"
                        onClick={(e) => openFloorImage(e, 0)}
                      // onClick={() =>
                      //   onFloorplanOpen(
                      //     "https://s2.q4cdn.com/175719177/files/doc_presentations/Placeholder-PDF.pdf"
                      //   )
                      // }
                      >
                        <i className="icon icon--floorplan" />
                        <span className="d-none d-md-inline-block">
                          Floorplan
                        </span>
                      </button>
                    </Col>
                  }
                  {props.data?.brochure?.length > 0 &&
                    <Col xs="auto" className="property-slider__option">
                      <a onClick={() => trackerVideo("Download Brochure")} href={props?.data?.brochure[0]?.srcUrl ? props?.data?.brochure[0]?.srcUrl : props?.data?.brochure[0]?.url ? props?.data?.brochure[0]?.url : ""} target="_blank" rel='noopener noreferrer'>
                        <button
                          // onClick={(e) => openbrouchureImage(e, 0)}
                          className="clear-btn d-flex align-items-center"
                        // onClick={() =>
                        //   onFloorplanOpen(
                        //     "https://s2.q4cdn.com/175719177/files/doc_presentations/Placeholder-PDF.pdf"
                        //   )
                        // }
                        >
                          <i className="icon icon--book-open" />
                          <span className="d-none d-md-inline-block">Brochure</span>
                        </button>
                      </a>
                    </Col>
                  }
                  {props?.data?.virtual_tour?.length > 0 &&
                    <Col
                      xs="auto"
                      className="property-slider__option d-lg-none video"
                    >
                      <button
                        className="clear-btn d-flex align-items-center"
                        onClick={() => handleClick()}
                      >
                        <i className="icon icon--video" />
                        <span className="d-none d-md-inline-block">
                          Video Tour
                        </span>
                      </button>
                    </Col>
                  }
                </Row>
              </div>
            </div>
          </Col>

          <Col
            xs="auto"
            className="property-slider__thumbnail d-none d-lg-flex flex-column"
          >
            {props.data?.images?.length > 1 ? <>
              {props.data?.images?.slice(1, 4)
                .map((value, index) => {
                  let processedImages1 = JSON.stringify({});
                  if (props.data?.imagetransforms?.images_Transforms) {
                    processedImages1 = props.data.imagetransforms.images_Transforms;
                  }
                  return (
                    <Col
                      key={index}
                      className="property-slider__thumbnail-image position-relative d-flex justify-content-center align-items-center"
                    >
                      {index === 0 ? (
                        <>
                          <div
                            className="position-absolute w-100 h-100 hover-zoom"
                            // onKeyDown={() => onGalleryOpen(slides, index + 1)}
                            // onClick={() => onGalleryOpen(slides, index + 1)}
                            onClick={props?.data?.virtual_tour?.length > 0 ? null : (e) => openPropertyImage(e, 0)}
                            role="button"
                          >
                            {/* <GatsbyImage image={value.placeholder} alt="property" /> */}
                            <div className="gatsby-image-wrapper">
                              <ImageRenderList
                                imagesources={value?.url}
                                renderer="srcSet"
                                imagename="property.images.detail"
                                attr={{ alt: `${props.data?.display_address} - ${sitenameseo}`, class: '' }}
                                imagetransformresult={processedImages1}
                                id={props.data?.id}
                                imagesrc={value?.srcUrl}
                                noimagename="coming-soon-image.Image.detail"
                              />
                            </div>
                          </div>
                          {props?.data?.virtual_tour?.length > 0 &&
                            <div className="property-slider__option video">
                              <button
                                onClick={() => handleClick()}
                                className="clear-btn position-relative d-flex align-items-center"
                              >
                                <i className="icon icon--video" />
                                <span>Video Tour</span>
                              </button>
                            </div>
                          }
                        </>
                      ) : (
                        <button
                          className="clear-btn position-absolute w-100 h-100 hover-zoom"
                          // onClick={() => onGalleryOpen(slides, index + 1)}
                          onClick={(e) => openPropertyImage(e, 0)}
                        >
                          {/* <GatsbyImage image={value.value} alt="property" /> */}
                          <div className="gatsby-image-wrapper">
                            <ImageRenderList
                              imagesources={value?.url}
                              renderer="srcSet"
                              imagename="property.images.detail"
                              attr={{ alt: `${props.data?.display_address} - ${sitenameseo}`, class: '' }}
                              imagetransformresult={processedImages1}
                              id={props.data?.id}
                              imagesrc={value?.srcUrl}
                              noimagename="coming-soon-image.Image.detail"
                            />
                          </div>
                        </button>
                      )}
                    </Col>
                  )
                })
              }</>
              : <>
                <Col
                  className="property-slider__thumbnail-image position-relative d-flex justify-content-center align-items-center"
                >
                  <div
                    className="position-absolute w-100 h-100 hover-zoom"
                    // onKeyDown={() => onGalleryOpen(slides, index + 1)}
                    // onClick={() => onGalleryOpen(slides, index + 1)}
                    // onClick={props?.data?.virtual_tour?.length > 0 ? null : (e) =>  openPropertyImage(e, 0)}
                    role="button"
                  >
                    {/* <GatsbyImage image={value.placeholder} alt="property" /> */}
                    <div className="gatsby-image-wrapper">
                      <Noimg imagename="coming-soon-image.Image.detail" />
                    </div>
                  </div>
                </Col>
                <Col
                  className="property-slider__thumbnail-image position-relative d-flex justify-content-center align-items-center"
                >
                  <button
                    className="clear-btn position-absolute w-100 h-100 hover-zoom"
                  // onClick={() => onGalleryOpen(slides, index + 1)}
                  // onClick={(e) => openPropertyImage(e, 0)}
                  >
                    {/* <GatsbyImage image={value.value} alt="property" /> */}
                    <div className="gatsby-image-wrapper">
                      <Noimg imagename="coming-soon-image.Image.detail" />
                    </div>
                  </button>
                </Col>
                <Col
                  className="property-slider__thumbnail-image position-relative d-flex justify-content-center align-items-center"
                >
                  <button
                    className="clear-btn position-absolute w-100 h-100 hover-zoom"
                  // onClick={() => onGalleryOpen(slides, index + 1)}
                  // onClick={(e) => openPropertyImage(e, 0)}
                  >
                    {/* <GatsbyImage image={value.value} alt="property" /> */}
                    <div className="gatsby-image-wrapper">
                      <Noimg imagename="coming-soon-image.Image.detail" />
                    </div>
                  </button>
                </Col>
              </>}
          </Col>
        </Row>

        {/* <Modal
          modalShow={modalShow}
          modalContent={modalContent}
          closeModal={closeModal}
        /> */}
        {/* Property image lightbox */}
        {isOpen && (
          <Lightbox
            mainSrc={propertyLightImages[photoIndex]}
            nextSrc={propertyLightImages[(photoIndex + 1) % propertyLightImages.length]}
            prevSrc={propertyLightImages[(photoIndex + propertyLightImages.length - 1) % propertyLightImages.length]}
            onCloseRequest={() => { setIsOpen(false); setPhotoIndex(1) }}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + propertyLightImages.length - 1) % propertyLightImages.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % propertyLightImages.length)
            }
          />
        )}
        {/* Property image lightbox */}
        {/* Property floorplan image lightbox */}
        {floorisOpen && (
          <Lightbox
            mainSrc={propertyLightImagesFloorplan[floorIndex]}
            nextSrc={floorplanImages.length > 1 ? propertyLightImagesFloorplan[(floorIndex + 1) % propertyLightImagesFloorplan.length] : undefined}
            prevSrc={floorplanImages.length > 1 ? propertyLightImagesFloorplan[(floorIndex + propertyLightImagesFloorplan.length - 1) % propertyLightImagesFloorplan.length] : undefined}
            onCloseRequest={() => setIsFloorOpen(false)}
            onMovePrevRequest={() =>
              setFloorIndex((floorIndex + propertyLightImagesFloorplan.length - 1) % propertyLightImagesFloorplan.length)
            }
            onMoveNextRequest={() =>
              setFloorIndex((floorIndex + 1) % propertyLightImagesFloorplan.length)
            }
          />
        )}
        {/* Property floorplan image lightbox */}

        {/* Property brouchure image lightbox */}
        {brouchureisOpen && (
          <Lightbox
            mainSrc={propertyLightImagesbrouchure[brouchureIndex]}
            nextSrc={brouchureImages.length > 1 ? propertyLightImagesbrouchure[(brouchureIndex + 1) % propertyLightImagesbrouchure.length] : undefined}
            prevSrc={brouchureImages.length > 1 ? propertyLightImagesbrouchure[(brouchureIndex + propertyLightImagesbrouchure.length - 1) % propertyLightImagesbrouchure.length] : undefined}
            onCloseRequest={() => setIsbrouchureOpen(false)}
            onMovePrevRequest={() =>
              setbrouchureIndex((brouchureIndex + propertyLightImagesbrouchure.length - 1) % propertyLightImagesbrouchure.length)
            }
            onMoveNextRequest={() =>
              setbrouchureIndex((brouchureIndex + 1) % propertyLightImagesbrouchure.length)
            }
          />
        )}
        {/* Property brouchure image lightbox */}
        {virtualTour && URL_Checker(virtualTour) ? (
          <PlayVideo url={virtualTour} isOpen={isPortalOpen} onClose={setIsPortalOpen} />
        ) : (
          <Portal
            onClose={() => {
              setIsPortalOpen(false)
            }}
            isOpen={isPortalOpen}
          >
            <ReactPlayer
              frameBorder="0"
              allowFullScreen
              url={virtualTour}
              modestbranding="1"
              controls={true}
              autoPlay={true}
              muted={false}
              playsinline={true}
              playing={play}
              width="100%"
              height="100vh"
              previewTabIndex={0}
              light={false}
            />
          </Portal>
        )}
      </Container>
    </div>
  )
}

export default PropertySlider
